


























import { mapMutations, mapGetters } from 'vuex'
import { Component, Vue } from 'vue-property-decorator'
import { checkForUpdates, applyUpdate, checkStoreStatus, disableStore, enableStore } from '@/api/system'
@Component({
  name: 'DisableStore'
})
export default class extends Vue {
  private isLoadingCheck = true

  private storeDisabled = null
  async created() {
    try {
      const { data } = await checkStoreStatus()
      if (data.successful) {
        // ...
        this.storeDisabled = data.disabled
      }
      this.isLoadingCheck = false
    } catch (error) {
      this.isLoadingCheck = false
    }
  }
  async disableStore() {
    try {
      const { data } = await disableStore()
      if (data.successful) {
        // ...
        this.storeDisabled = true
      }
      this.isLoadingCheck = false
    } catch (error) {
      this.isLoadingCheck = false
    }
  }
  async enableStore() {
    try {
      const { data } = await enableStore()
      if (data.successful) {
        // ...
        this.storeDisabled = false
      }
      this.isLoadingCheck = false
    } catch (error) {
      this.isLoadingCheck = false
    }
  }
}
